import React, { useState, useEffect } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Cookies from 'js-cookie'
import { Link, Image } from 'newComponents'
import CtaArrow from '../../../components/ctaArrow'
import './styles.scss'

const cookieDomain = `${process.env.GATSBY_COOKIE_DOMAIN}`

const BannerTeaser = () => {
  // API DATA
  const bannerQuery = graphql`
    query {
      ...BannerSettings
    }
  `

  const { prismicSettings } = useStaticQuery(bannerQuery)
  const { data } = prismicSettings
  const {
    show_banner: bannerToggle,
    cta_link: ctaLink,
    cta_text: ctaText,
    image,
    content,
    cookie_id: cookieId,
    link_color: linkColor,
    logo_alignment: alignment
  } = data
  const contentHtml = content?.html
  const customId = !cookieId ? 'no custom cookie id set' : cookieId.text
  const [showBanner, setShowBanner] = useState(bannerToggle)

  useEffect(() => {
    const isDisabled = Cookies.get(customId)
    setShowBanner(bannerToggle && isDisabled === undefined)
  }, [])

  const handleCloseBanner = () => {
    Cookies.set(customId, false, {
      domain: cookieDomain,
      expires: 30
    })
    setShowBanner(false)
  }

  if (!showBanner) {
    return null
  }

  return (
    <>
      {showBanner && (
        <section className="banner-position">
          <div className={`banner-content ${alignment === 'right' ? 'banner-content-right' : ''}`}>
            {image && (
              <div className="banner-logo">
                <Image image={image} alt={image.alt ? image.alt : 'Banner image'} />
              </div>
            )}
            {contentHtml && <div className="banner-content-text" dangerouslySetInnerHTML={{ __html: contentHtml }} />}
            <Link
              id="banner-button"
              className={`cta u-nowrap ${alignment === 'right' ? 'banner-button-alignment' : ''}`}
              to={ctaLink.url}
              style={{ color: linkColor }}
            >
              {ctaText.text}
              <CtaArrow />
            </Link>
            <button onClick={handleCloseBanner} className="banner-close-button" type="button" aria-label="close" />
          </div>
        </section>
      )}
    </>
  )
}

export default BannerTeaser
